import React from "react";
import "./AboutComp.css";
import { useLocation, useNavigate } from "react-router-dom";

const AboutComp = ({ data }) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-box">
          <div className="about-left">
            <div className="image-wrapper">
              <img src={data?.image?.url} alt="classroom" />
            </div>
          </div>

          <div className="about-right">
            <p className="founder-subtitle">{data?.subTitle}</p>

            <h2 className="founder-title">
              {data?.title?.split(" ").slice(0, -2).join(" ")}
              <span> {data?.title?.split(" ").slice(-2).join(" ")}</span>
            </h2>

            {data?.description?.map((block, index) => {
              // helper for inline formatting
              const renderChildren = (children) =>
                children?.map((child, i) => {
                  let text = child.text;

                  if (child.bold) {
                    text = <strong key={i}>{text}</strong>;
                  }

                  if (child.italic) {
                    text = <em key={i}>{text}</em>;
                  }

                  if (child.underline) {
                    text = <u key={i}>{text}</u>;
                  }

                  if (child.strikethrough) {
                    text = <s key={i}>{text}</s>;
                  }

                  if (child.code) {
                    text = <code key={i}>{text}</code>;
                  }

                  // links
                  if (child.type === "link") {
                    return (
                      <a
                        key={i}
                        href={child.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {child.children?.map((c) => c.text).join("")}
                      </a>
                    );
                  }

                  return <React.Fragment key={i}>{text}</React.Fragment>;
                });

              // headings
              if (block.type === "heading") {
                switch (block.level) {
                  case 1:
                    return (
                      <h1 key={index}>{renderChildren(block.children)}</h1>
                    );
                  case 2:
                    return (
                      <h2 key={index}>{renderChildren(block.children)}</h2>
                    );
                  case 3:
                    return (
                      <h3 key={index}>{renderChildren(block.children)}</h3>
                    );
                  case 4:
                    return (
                      <h4 key={index}>{renderChildren(block.children)}</h4>
                    );
                  case 5:
                    return (
                      <h5 key={index}>{renderChildren(block.children)}</h5>
                    );
                  case 6:
                    return (
                      <h6 key={index}>{renderChildren(block.children)}</h6>
                    );
                  default:
                    return null;
                }
              }

              // paragraph
              if (block.type === "paragraph") {
                return (
                  <p className="founder-desc" key={index}>
                    {renderChildren(block.children)}
                  </p>
                );
              }

              // unordered / ordered list
              if (block.type === "list") {
                const ListTag = block.format === "ordered" ? "ol" : "ul";

                return (
                  <ListTag key={index}>
                    {block.children?.map((item, idx) => (
                      <li key={idx}>
                        {item.children?.map((child, i) => (
                          <React.Fragment key={i}>{child.text}</React.Fragment>
                        ))}
                      </li>
                    ))}
                  </ListTag>
                );
              }

              // quote
              if (block.type === "quote") {
                return (
                  <blockquote key={index}>
                    {renderChildren(block.children)}
                  </blockquote>
                );
              }

              // code block
              if (block.type === "code") {
                return (
                  <pre key={index}>
                    <code>{block.children?.map((c) => c.text).join("")}</code>
                  </pre>
                );
              }

              return null;
            })}
            {location.pathname !== "/about" && (
              <button
                className="btn-outline"
                onClick={() => navigate(data?.buttonLink)}
              >
                {data?.button}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutComp;
